import { AxiosError } from 'axios';
import { RetryApiAlert } from '../../../../../shared/components/RetryApiAlert/RetryApiAlert';
import { getErrorMessageFromAxiosError } from '../../../../../request/utils';

interface PipelineCreateSelectDestinationEmptyProps {
  retry: VoidFunction;
  error: object | null;
}

export function PipelineCreateSelectDestinationError({
  retry,
  error
}: PipelineCreateSelectDestinationEmptyProps) {
  return (
    <div style={{ marginTop: 140 }}>
      <RetryApiAlert
        title='Failed to fetch the Destinations'
        subTitle={
          getErrorMessageFromAxiosError(error as AxiosError) || 'Retry loading the Destinations'
        }
        secondaryCTAProps={{ onClick: retry }}
      />
    </div>
  );
}
